export default function confirmPopup(text, confirmedCb, canceledCb) {
	Modals.create("confirm-popup", {
		title: `Requires confirmation`,
		body: modal => {
			return `
				<p>${text}</p>
			`;
		},
		actions: modal => {
			const buttonNO = document.createElement("button");
			buttonNO.classList.add("btn");
			buttonNO.classList.add("btn-primary");
			buttonNO.innerHTML = "NO";

			buttonNO.addEventListener("click", e => {
				modal.close();
				canceledCb();
			});

			const buttonYES = document.createElement("button");
			buttonYES.classList.add("btn");
			buttonYES.classList.add("btn-warning");
			buttonYES.innerHTML = 'YES';

			buttonYES.addEventListener("click", e => {
				modal.close();
				confirmedCb();
			});

			return [ buttonNO, buttonYES ];
		}
	}).show();
}